import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useI18n } from "../context/I18nContext";

export default function MyOrders() {
  const { t, lang } = useI18n();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/my").then(({ data }) => { setOrders(data); setLoading(false); });
  }, []);

  if (loading) return <div className="max-w-5xl mx-auto px-6 py-20 text-slate-500">{t("common.loading")}</div>;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12" data-testid="orders-page">
      <h1 className="font-display font-black text-4xl tracking-tighter mb-8">{t("orders.title")}</h1>
      {orders.length === 0 ? (
        <div className="border border-dashed border-slate-300 py-20 text-center text-slate-500" data-testid="orders-empty">
          {t("orders.empty")}
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border border-slate-200 p-6" data-testid={`order-${o.id}`}>
              <div className="flex flex-wrap justify-between gap-4">
                <div>
                  <div className="label-mono text-slate-500">{t("orders.orderId")} #{o.id.slice(0, 8)}</div>
                  <div className="font-display font-bold text-lg mt-1">
                    {new Date(o.created_at).toLocaleString(lang === "ar" ? "ar-QA" : "en-GB")}
                  </div>
                </div>
                <div className="text-end">
                  <div className="font-display font-black text-2xl text-[#8D1B3D]">
                    {o.total.toFixed(2)} {t("common.currency")}
                  </div>
                  <div className="flex gap-2 mt-2 justify-end">
                    <Badge text={o.status} kind="status" />
                    <Badge text={o.payment_method === "cod" ? t("checkout.cod") : (o.payment_status === "paid" ? "paid" : "pending")} kind="payment" />
                  </div>
                </div>
              </div>
              <div className="mt-4 grid sm:grid-cols-3 gap-3">
                {o.items.map((it) => (
                  <div key={it.product_id} className="flex items-center gap-3 border border-slate-100 p-2">
                    <img src={it.image_url} className="w-12 h-12 object-cover" alt="" />
                    <div className="text-sm">
                      <div className="font-bold line-clamp-1">{lang === "ar" ? it.name_ar : it.name_en}</div>
                      <div className="text-slate-500 text-xs">x {it.quantity}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Badge({ text, kind }) {
  const c = kind === "status"
    ? "bg-slate-900 text-white"
    : (text === "paid" ? "bg-emerald-600 text-white" : "bg-amber-500 text-white");
  return <span className={`label-mono px-2 py-1 ${c}`}>{text}</span>;
}
